export default __webpack_public_path__ + "static/media/11_whale2.919d3d1b.webp";